export default "__VITE_ASSET__BAtpFJha__"